export function initMediaEntrance() {
    function showMedia(el) {
        if (el instanceof Element) {
            el.classList.add('media-loaded');
            setTimeout((el) => {
                if (el instanceof Element) {
                    el.classList.remove('media-to-show', 'media-loaded');
                }
            }, 400, el);
        }
    }

    document.querySelectorAll('.media-to-show').forEach(el => {
        if (el.complete) {
            showMedia(el);
        } else {
            if (el.matches('video')) {
                el.addEventListener('canplaythrough', e => {
                    showMedia(e.target);
                });
            } else {
                el.addEventListener('load', e => {
                    showMedia(e.target);
                });
            }
        }
    });
}